import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import {
  isCheckActionsPermission,
  isCheckModuleActionForNavigationPath,
} from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import { RootState } from "src/redux/store";
import AddQuicknquryFormWrapper from "../QuickInquiry/Add/AddQuicknquryFormWrapper";
import InquiryFilterDialogWrapper from "./FilterDialog/InquiryFilterDialogWrapper";

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const InquiryListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const navigate = useNavigate();
  const { userType } = useSelector((state: RootState) => state.auth);
  const [quickInquiryDialog, setQuickInquiryDialog] = useState(false);
  const [isOpenFilterDialog, setIsOpenFilterDialog] = useState(false);
  return (
    <SideNavLayout>
      <div className="flex flex-col  gap-6 p-4">
        {/* Page Header */}
        <div className="">
          <ATMPageHeader
            isFilter
            onFilterClick={() => {
              setIsOpenFilterDialog(true);
            }}
            pageTitle="Inquiries"
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            hideAddButton={
              !isCheckActionsPermission({
                moduleName: UserModuleNameTypes.INQUIRIES,
                actionName: UserModuleActionTypes.ADD,
              })
            }
            buttonProps={{
              btnName: "Add New",
              onClick: () => {
                navigate("add");
              },
            }}
            showAnotherAddButton={
              isCheckActionsPermission({
                moduleName: UserModuleNameTypes.INQUIRIES,
                actionName: UserModuleActionTypes.ADD_QUICK_INQUIRIE,
              })
            }
            anotherButtonProps={{
              btnName: "Add Quick Inquiry",
              onClick: () => {
                setQuickInquiryDialog(true);
              },
            }}
          />
        </div>

        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col">
          <ATMTable
            onRowClick={(row: any) => {
              if (userType === "ADMIN") {
                navigate(`edit/${row?._id}/followup`);
              } else {
                isCheckModuleActionForNavigationPath(
                  UserModuleNameTypes.INQUIRIES,
                  `edit/${row?._id}`,
                  navigate
                );
              }
            }}
            columns={columns}
            rows={rows}
            rowExtraClasses={() => "min-h-[40px]"}
            isLoading={isTableLoading}
          />
        </div>

        <div className="p-4 py-2 flex justify-end">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
      </div>
      {quickInquiryDialog && (
        <AddQuicknquryFormWrapper
          onClose={() => {
            setQuickInquiryDialog(false);
          }}
        />
      )}
      {isOpenFilterDialog && (
        <InquiryFilterDialogWrapper
          onClose={() => {
            setIsOpenFilterDialog(false);
          }}
        />
      )}
    </SideNavLayout>
  );
};

export default InquiryListing;
